import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

/**
 * Componente para proteger rotas exclusivas do Super Admin
 * Redireciona usuários não autorizados
 */
export default function SuperAdminRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-slate-600">Carregando...</p>
        </div>
      </div>
    );
  }

  // Se não estiver logado, permitir acesso (página de login)
  if (!user) {
    return children;
  }

  // Se estiver logado mas não for Super Admin, redirecionar
  const isSuperAdmin = user.roles?.some(role => role.type === 'SUPER_ADMIN');
  
  if (!isSuperAdmin) {
    // Redirecionar para o slug da empresa do usuário
    const companySlug = user.company?.layout?.slug;
    if (companySlug) {
      return <Navigate to={`/${companySlug}/dashboard`} replace />;
    }
    // Se não tiver slug, redirecionar para dashboard padrão
    return <Navigate to="/" replace />;
  }

  return children;
}
